<div class="sidenav-content" @routeAnimation>
	<ng-container *ngIf="batchData else loading">
		<div class="card-title-block-non-sticky">
			<copo-back-button></copo-back-button>
			<span class="card-title-label" translate>aqdb.metal.unit</span>
			<span class="card-title-label card-title-batch-ref">{{ batchData.batchReference ? batchData.batchReference : UNDERSCORE }}</span>
			<div class="card-title-label">
				<mat-panel-title class="card-content-title">
					<span class="card-sub-content-label"><mat-icon  class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
					<div class="card-content-label" translate>aqdb.measured.datas</div>
					<span class="card-sub-content-label"><mat-icon  class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
					<div class="card-content-label" translate>aqdb.datas.transmitted.on.certificate</div>
					<span class="card-sub-content-label"><mat-icon  class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
					<div class="card-content-label" translate>aqdb.modelled.data</div>
				</mat-panel-title>
			</div>
		</div>

		<copo-metal-unit [batchData]="batchData"></copo-metal-unit>
		<copo-shipping-characteristics [batchData]="batchData"></copo-shipping-characteristics>
		<copo-other-characteristics [batchData]="batchData"></copo-other-characteristics>

		<ng-container *ngIf="batchData.segments">
			<ng-container *ngFor="let segment of batchData.segments">
				<copo-mechanical-characteristics [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-mechanical-characteristics>
				<copo-chemical-characteristics [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-chemical-characteristics>
				<copo-magnetic-characteristics [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-magnetic-characteristics>
				<copo-coating-surface-characteristics [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-coating-surface-characteristics>
			</ng-container>
		</ng-container>
	</ng-container>
</div>
<div *ngIf="batchData === undefined && !isLoading" class="batch-not-found-text" translate>aqdb.batch.not.found</div>
<ng-template #loading>
	<ng-container *ngIf="isLoading">
		<copo-loading-spinner></copo-loading-spinner>
	</ng-container>
</ng-template>